import { Fonts } from 'components/base-ui'
import useLanguage from 'hooks/useLanguage'
import React, { FC, useRef } from 'react'
import { useDraggable } from 'react-use-draggable-scroll'
import styled from 'styled-components'

export interface Category {
  nameEn: string
  nameTh: string
  image: string
  id: number
}
type Props = {
  selectedID: number
  categories: Category[]
  onSelectCategory: (category: Category) => void
  containerID?: string
  itemClass?: string
  thumbnailClass?: string
}

const CategorySection: FC<Props> = ({
  selectedID,
  categories,
  onSelectCategory,
  containerID = '',
  itemClass = '',
  thumbnailClass = '',
}) => {
  const containerRef = useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>
  const { events } = useDraggable(containerRef, { applyRubberBandEffect: true })
  const { getPropertyByLang } = useLanguage()

  return (
    <Wrapper id={containerID} {...events} ref={containerRef}>
      {categories.map((category) => (
        <Item
          className={itemClass}
          key={category.id}
          active={selectedID === category.id}
          onClick={() => onSelectCategory(category)}
        >
          {category.image ? (
            <>
              <ThumbnailWrapper className={thumbnailClass}>
                <Thumbnail alt="" src={category.image} />
              </ThumbnailWrapper>
              <Name>
                {getPropertyByLang({
                  en: category.nameEn,
                  th: category.nameTh,
                })}
              </Name>
            </>
          ) : (
            <>
              <ThumbnailWrapper className={thumbnailClass}>
                <Thumbnail alt="" src="/assets/dine-in/category-icon.svg" style={{ padding: 10 }} />
              </ThumbnailWrapper>
              <Name>
                {getPropertyByLang({
                  en: category.nameEn,
                  th: category.nameTh,
                })}
              </Name>
            </>
          )}
        </Item>
      ))}
    </Wrapper>
  )
}

export default CategorySection

const Wrapper = styled.div`
  display: flex;
  align-items: inherit;
  column-gap: 8px;
  padding: 15px 8px 8px 15px;
  scroll-padding-left: 15px;
  flex-shrink: 0;
  overflow-y: hidden;
  flex-wrap: nowrap;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  scroll-snap-type: x mandatory;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  ::-webkit-scrollbar {
    opacity: 0;
  }
`

export const Item = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 8px 10px 8px;
  width: 25%;
  min-width: 85px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.baseGrey};
  background: ${({ theme }) => theme.colors.white};
  transition: all 0.3s ease-out;
  scroll-snap-align: start;
  ${({ active, theme }) =>
    active &&
    `
  color: ${theme.colors.white};
  background: ${theme.colors.primary};
  `}
`

export const Name = styled(Fonts.SmallTitleMedium)`
  font-size: 12.5px;
  width: 100%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const ThumbnailWrapper = styled.div`
  height: 70px;
`

export const Thumbnail = styled.img`
  width: 100%;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 15px;
  transition: all 0.3s ease-out;
`
